import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { formatHebrewDate } from '../../services/util.service'
import { fetchUserById } from '../../store/slices/user.slice'

export function PostAuthorLine({ userId, createdAt }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const users = useSelector((state) => state.userModule.users)
  const author = users.find((user) => user._id === userId)

  // אם המשתמש לא קיים עדיין, טען אותו
  useEffect(() => {
    if (!author && userId) {
      dispatch(fetchUserById(userId))
    }
  }, [author, userId, dispatch])

  return (
    <h5 className="text-muted text-xs">
      עלה ב {formatHebrewDate(createdAt)}, ע"י{' '}
      {author ? (
        <span
          className="hover:underline cursor-pointer"
          onClick={() => navigate(`/user/${author.username}`)}
        >
          {author.nickname}
        </span>
      ) : (
        <span className="text-muted">משתמש</span>
      )}
    </h5>
  )
}
